import { useEffect, useState } from "react";

import {

    getFavorites,

    toggleFavorite,

} from "../services/favoriteService";

function useFavorites() {

    const [favorites, setFavorites] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    // ====================================
    // Load Favorites
    // ====================================

    const loadFavorites = async () => {

        try {

            setLoading(true);

            const res = await getFavorites();

            if (res.success) {

                setFavorites(res.favorites);

            }

        } catch (err) {

            setError(

                err.response?.data?.message ||

                "Failed to load favorites."

            );

        } finally {

            setLoading(false);

        }

    };

    // ====================================
    // Toggle Favorite
    // ====================================

    const handleFavorite = async (foodId) => {

        try {

            await toggleFavorite(foodId);

            await loadFavorites();

        } catch (err) {

            console.log(err);

        }

    };

    useEffect(() => {

        loadFavorites();

    }, []);

    return {

        favorites,

        loading,

        error,

        reloadFavorites: loadFavorites,

        toggleFavorite: handleFavorite,

    };

}

export default useFavorites;